import React, { useState } from "react";
import Dropdown from "components/dropdown";
import { useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdNotificationsOutline } from "react-icons/io";
import avatar from "assets/img/avatars/avatar.png";
import { getSecureLocalItem } from "utils/secureSessionStorage";
import { logoutAction } from "store/features/auth/authActions";
import { useDispatch } from "react-redux";
import PasswordResetModal from '../../views/admin/Dasboard/ResetPassword';

const Navbar = (props) => {
  const [darkmode, setDarkmode] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Retrieve from session storage
  const role = getSecureLocalItem("role");

  const userName =
    role === "admin"
      ? "👋 Hi Admin ! Welcome to Snori"
      : "👋 Hi Vendor ! Welcome to Snori";

  const handleLogout = () => {
    dispatch(logoutAction());
    navigate("/auth/sign-in");
  };

  return (
    <>
      <nav className="sticky top-4 z-40 flex justify-end">
        <div className="relative mt-[3px] flex h-[61px] w-[250px] flex-grow items-center justify-center gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[300px] md:flex-grow-0 md:gap-4 xl:w-[250px] xl:gap-2">
          {/* start Notification */}
          <Dropdown
            button={
              <p className="cursor-pointer">
                <IoMdNotificationsOutline className="h-8 w-8 text-gray-600 dark:text-white" />
              </p>
            }
            animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
            children={
              <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
                <div className="flex items-center justify-between">
                  <p className="text-base font-bold text-navy-700 dark:text-white">
                    Notification
                  </p>
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    Mark all read
                  </p>
                </div>

                <button className="flex w-full items-center">
                  <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                    <FaBell />
                  </div>
                  <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                    <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                      New Update: Recharge App
                    </p>
                    <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                      A new update for your downloaded item is available!
                    </p>
                  </div>
                </button>

                <button className="flex w-full items-center">
                  <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                    <FaBell />
                  </div>
                  <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                    <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                      New Update: Recharge App
                    </p>
                    <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                      A new update for your downloaded item is available!
                    </p>
                  </div>
                </button>
              </div>
            }
            classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
          />
          <Dropdown
            button={
              <img
                className="h-10 w-10 rounded-full"
                src={avatar}
                alt="Elon Musk"
              />
            }
            children={
              <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
                <div className="p-4">
                  <div className="flex flex-col items-start gap-2">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {userName}
                    </p>{" "}
                  </div>
                </div>
                <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />
                
                {/* Reset Password Button */}
                <div
                  onClick={() => setIsModalOpen(true)}
                  className="text-md cursor-pointer rounded-md text-center font-medium bg-indigo-600 text-white  p-2 m-4 "
                >
                  Reset Password
                </div>
                
                <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />
                
                <div
                  onClick={handleLogout}                            
                  className="text-md cursor-pointer rounded-lg bg-red-600  m-4 p-2 text-center font-medium text-white"
                >
                  Log Out
                </div>
              </div>
            }
            classNames={"py-2 top-8 -left-[180px] w-max"}
          />
        </div>
      </nav>
      
      {/* Password Reset Modal (outside the nav) */}
      <PasswordResetModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default Navbar;